// Shared join-form validation. The backend enforces the same rules — this
// copy exists so students get instant feedback while typing.

const BLOCKED_NAME_WORDS = [
  "fuck", "fuk", "fck", "shit", "bitch", "bastard", "asshole", "arsehole",
  "cunt", "dick", "cock", "penis", "vagina", "pussy", "boobs", "nigger",
  "nigga", "rape", "rapist", "sex", "sexy", "porn", "xxx", "slut", "whore",
  "gandu", "gaand", "gand", "chutiya", "chutiye", "chut", "lund", "loda",
  "lauda", "madarchod", "maderchod", "behenchod", "bhenchod", "bhosda",
  "bhosdi", "bhosdike", "bhosadi", "randi", "harami", "kutta", "kutti",
  "kamina", "kamine", "suar", "chodu", "chod", "jhaat", "tatti", "hijra",
  "raand", "boka", "chuda", "khanki", "magi", "bal", "sala", "saala",
];

const flatten = (name) => {
  const low = (name || "").toLowerCase().replace(/[^a-z0-9\u0980-\u09FF\u0900-\u097F]/g, "");
  let out = "";
  for (const ch of low) if (out[out.length - 1] !== ch) out += ch;
  return out;
};

// Returns an error message, or null when the name is acceptable.
export const nameRejection = (name) => {
  const raw = (name || "").trim();
  if (raw.length < 2) return "Please enter your real name (at least 2 characters).";
  if (raw.length > 40) return "That name is too long.";
  if (!/[A-Za-z\u0980-\u09FF\u0900-\u097F]/.test(raw)) return "Please enter your name using letters.";
  if (/https?:\/\/|www\.|@|\d{6,}/.test(raw)) return "Names cannot contain links, emails or long numbers.";
  const flat = flatten(raw);
  if (BLOCKED_NAME_WORDS.some((w) => flat.includes(w)))
    return "That name isn't allowed. Please use your real name.";
  return null;
};

// Returns the 10-digit local number, or null when invalid.
export const normalizeIndianMobile = (value) => {
  let n = (value || "").replace(/\D/g, "");
  if (n.length === 12 && n.startsWith("91")) n = n.slice(2);
  else if (n.length === 13 && n.startsWith("091")) n = n.slice(3);
  else if (n.length === 11 && n.startsWith("0")) n = n.slice(1);
  return n.length === 10 && "6789".includes(n[0]) ? n : null;
};
